 
// import React, { useState } from "react";
// import emailjs from 'emailjs-com';
// import UserPageHeader from '../components/UserPageHeader';

// const ContactPage = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const serviceID = 'service_v6rljze';     // Replace with your actual service ID
//     const templateID = 'template_iipj1hd';   // Replace with your actual template ID
//     const userID = '7t6ZwyKP7geniFJn0';      // Replace with your actual user ID (public key)

//     emailjs.send(serviceID, templateID, formData, userID)
//       .then((response) => {
//         alert('Message sent successfully!');
//         setFormData({ name: '', email: '', subject: '', message: '' });
//       })
//       .catch((error) => {
//         console.error(error);
//         alert('Failed to send message. Please try again later.');
//       });
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-white to-[#e6f4f1] text-gray-800 flex flex-col items-center">
//       <UserPageHeader />

//       {/* Header */}
//       <div className="text-center mt-10 px-4">
//         <h1 className="text-3xl font-bold mb-4">Get In Touch</h1>
//         <p className="max-w-xl mx-auto text-gray-600">
//           We'll provide reliable, well-maintained vehicles and build lasting customer trust with each rental, paving the way for you to travel comfortably.
//         </p>
//       </div>

//       {/* Contact Section */}
//       <div className="mt-10 flex flex-col lg:flex-row bg-white shadow-2xl rounded-xl max-w-5xl w-full p-6 gap-6 mx-4 mt-5">
//         {/* Contact Info */}
//         <div className="bg-blue-600 text-white rounded-xl p-6 flex flex-col justify-between lg:w-1/2">
//           <div>
//             <h3 className="text-xl font-semibold mb-2">Contact Information</h3>
//             <p className="text-sm mb-6">
//               We offer high-quality vehicles and ensure dependable service across at least 40 major travel routes and locations.
//             </p>
//             <div className="mb-4">
//               <p className="font-semibold mb-1">📞 Phone</p>
//               <p className="text-sm">+0712345678</p>
//               <p className="text-sm">+0712345678</p>
//             </div>
//             <div className="mb-4">
//               <p className="font-semibold mb-1">📧 Email</p>
//               <p className="text-sm">Support@rental.com</p>
//             </div>
//             <div className="mb-2">
//               <p className="font-semibold mb-1">📍 Location</p>
//               <p className="text-sm">Colombo, Sri Lanka</p>
//             </div>
//           </div>
//           <div className="mt-6">
//             <div className="w-24 h-24 bg-white opacity-20 rounded-full mx-auto lg:mx-0"></div>
//           </div>
//         </div>

//         {/* Contact Form */}
//         <div className="flex-1">
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div className="flex gap-4">
//               <div className="flex-1">
//                 <label className="block text-sm mb-1">Your Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="John Silva"
//                   className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="flex-1">
//                 <label className="block text-sm mb-1">Your Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="hello@gmail.com"
//                   className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm mb-1">Your Subject</label>
//               <input
//                 type="text"
//                 name="subject"
//                 placeholder="I want to book a car  quickly"
//                 className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//                 value={formData.subject}
//                 onChange={handleChange}
//               />
//             </div>

//             <div>
//               <label className="block text-sm mb-1">Message</label>
//               <textarea
//                 name="message"
//                 rows="4"
//                 placeholder="Write here your message"
//                 className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//                 value={formData.message}
//                 onChange={handleChange}
//                 required
//               ></textarea>
//             </div>

//             <button
//               type="submit"
//               className="bg-blue-600 text-white px-5 py-2 rounded-md hover:bg-[#00a895]"
//             >
//               Send Message
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Footer */}
//       <footer className="mt-16 text-center text-sm text-gray-500 space-x-4">
//         <span>Terms</span>
//         <span>Privacy</span>
//         <span>Cookies</span>
//       </footer>
//     </div>
//   );
// };

// export default ContactPage;





import React, { useState } from "react";
import emailjs from 'emailjs-com';
import UserPageHeader from '../components/UserPageHeader';
import { FiMail, FiPhone, FiMapPin, FiSend } from 'react-icons/fi';
import { FaCarAlt } from 'react-icons/fa';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const serviceID = 'service_v6rljze';
    const templateID = 'template_iipj1hd';
    const userID = '7t6ZwyKP7geniFJn0';

    emailjs.send(serviceID, templateID, formData, userID)
      .then((response) => {
        alert('Message sent successfully!');
        setFormData({ name: '', email: '', subject: '', message: '' });
      })
      .catch((error) => {
        console.error(error);
        alert('Failed to send message. Please try again later.');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 flex flex-col">
      <UserPageHeader />
     <div className="mt-28"></div>
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-blue-600 to-teal-500 py-12 px-4 text-center text-white">
        
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="relative max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl max-w-2xl mx-auto">
            We're here to help you with your car rental needs. Get in touch with our team for any inquiries.
          </p>
          <div className="mt-8">
            <FaCarAlt className="inline-block text-5xl opacity-20" />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl font-bold mb-6 text-gray-800">Our Information</h2>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="bg-blue-100 p-3 rounded-full mr-4">
                    <FiPhone className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Phone</h3>
                    <p className="text-gray-600">+071 234 5678</p>
                    <p className="text-gray-600">+071 234 5679</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-teal-100 p-3 rounded-full mr-4">
                    <FiMail className="text-teal-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Email</h3>
                    <p className="text-gray-600">Support@rental.com</p>
                    <p className="text-gray-600">Bookings@rental.com</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="bg-purple-100 p-3 rounded-full mr-4">
                    <FiMapPin className="text-purple-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Location</h3>
                    <p className="text-gray-600">123 Rental Street</p>
                    <p className="text-gray-600">Colombo, Sri Lanka</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl font-bold mb-6 text-gray-800">Working Hours</h2>
              <div className="space-y-4">
                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium">Monday - Friday</span>
                  <span className="text-gray-600">8:00 AM - 8:00 PM</span>
                </div>
                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium">Saturday</span>
                  <span className="text-gray-600">9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Sunday</span>
                  <span className="text-gray-600">10:00 AM - 4:00 PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Your Name</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="John Silva"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Your Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="hello@gmail.com"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                <input
                  type="text"
                  name="subject"
                  placeholder="I want to book a car quickly"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea
                  name="message"
                  rows="5"
                  placeholder="Write your message here..."
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`w-full flex items-center justify-center px-6 py-3 rounded-lg text-white font-medium ${isSubmitting ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'} transition`}
              >
                {isSubmitting ? (
                  'Sending...'
                ) : (
                  <>
                    <FiSend className="mr-2" />
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="bg-gray-100 py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl font-bold mb-6 text-center">Our Location</h2>
          <div className="bg-white p-4 rounded-xl shadow-lg">
            <div className="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden">
              {/* Replace with your actual map embed */}
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.798511757687!2d79.8604544153931!3d6.921682495003982!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae2593cf65a1e9d%3A0xe13da4b400e2d38c!2sColombo!5e0!3m2!1sen!2slk!4v1620000000000!5m2!1sen!2slk" 
                width="100%" 
                height="450" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy"
                className="rounded-lg"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="text-xl font-bold flex items-center">
              <FaCarAlt className="mr-2 text-blue-400" />
              CarRental
            </h3>
            <p className="text-gray-400 mt-1">Your trusted car rental partner</p>
          </div>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-300 hover:text-white transition">Terms</a>
            <a href="#" className="text-gray-300 hover:text-white transition">Privacy</a>
            <a href="#" className="text-gray-300 hover:text-white transition">Cookies</a>
            <a href="#" className="text-gray-300 hover:text-white transition">Help</a>
          </div>
        </div>
        <div className="max-w-7xl mx-auto mt-6 pt-6 border-t border-gray-700 text-center text-gray-400 text-sm">
          © {new Date().getFullYear()} CarRental. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;